module.exports = __webpack_public_path__ + "fonts/pt_root-ui_bold.b64e0b6.woff";